import ShipbobAppSettings from '../appSettings/appSetting'
import HttpWrapper from '../utils/http/httpWrapper'
import toastr from 'toastr'

const SHIPBOBV2_API = ShipbobAppSettings.shipbobV2Api
const MERCHANTPRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl

export default class AdminService {
  static urls () {
    return {
      getAdminPageData: SHIPBOBV2_API + '/api/admin/getAdminPageData',
      getAccountManagerData: SHIPBOBV2_API + '/api/admin/getAccountManagerData',
      updateAdminPageData: SHIPBOBV2_API + '/api/admin/updateAdminPageData',
      saveHomeCountry: MERCHANTPRICING_API + 'user/SaveHomeCountry'
    }
  }

  static handleSaveHomeCountry (res) {
    const DEFAULT_ERROR = 'Unable to switch merchant home country.'
    const errorMessage = res?.response?.data?.title

    return toastr.error(errorMessage || DEFAULT_ERROR)
  }

  static async getAdminPageData () {
    const request = {
      Url: this.urls().getAdminPageData
    }
    return await HttpWrapper.Get(request)
  }

  static async getAccountManagerData () {
    const request = {
      Url: this.urls().getAccountManagerData
    }
    return await HttpWrapper.Get(request)
  }

  static async updateAdminPageData (payload) {
    const request = {
      Url: this.urls().updateAdminPageData,
      Data: payload
    }
    return await HttpWrapper.Post(request)
  }

  static getPricingPlanModel (plan, userFulfillmentCenters) {
    const userFCsForRegion = Array.isArray(userFulfillmentCenters) && userFulfillmentCenters.filter(ufc => plan.fulfillmentCenters.includes(ufc.fulfillment_center_id))
    return {
      Country: { Id: plan.countryISO, Name: plan.countryName },
      PricingRegion: { Id: plan.pricingRegionId, Name: plan.pricingRegionName },
      MasterLocations: Array.isArray(userFulfillmentCenters) && userFCsForRegion.map(fc => fc.fulfillment_center_name),
      DomesticPlan: { Id: plan.domesticPlanID, Name: plan.domesticPlanName },
      InternationalPlan: { Id: plan.internationalPlanID, Name: plan.internationalPlanName }
    }
  }

  static async saveHomeCountry (countryCode) {
    const request = {
      Url: `${this.urls().saveHomeCountry}/${countryCode}`
    }
    return await HttpWrapper.Post(request, undefined, this.handleSaveHomeCountry, true)
  }
}
